import * as React from "react";
const SvgIcTv = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M16 19H23V2H1V19H8V22H16V19ZM20 16H4V5H20V16Z" fill="currentColor" /></svg>;
export default SvgIcTv;